// =============================================================================
// KH Kinetics — Child theme JS entry
// Behaviors 1–4 from the behavior map (block-map.md §4).
// =============================================================================

document.addEventListener('DOMContentLoaded', () => {
  // Mark body as JS-loaded so .reveal elements start hidden for animation
  document.body.classList.add('js-loaded');

  // ── Behavior 1: Hamburger toggle ──────────────────────────────────────────
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');

  if (hamburger && mobileNav) {
    const setOpen = (open) => {
      mobileNav.classList.toggle('open', open);
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    hamburger.addEventListener('click', () => {
      const isOpen = mobileNav.classList.contains('open');
      setOpen(!isOpen);
    });

    // ── Behavior 2: Close mobile nav on any link/button click ─────────────
    mobileNav.addEventListener('click', (e) => {
      if (e.target.closest('a') || e.target.closest('button')) {
        setOpen(false);
      }
    });
  }

  // ── Behavior 3: Navbar scroll shadow ──────────────────────────────────────
  const navbar = document.querySelector('.navbar');
  if (navbar) {
    const onScroll = () => {
      navbar.classList.toggle('scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // set initial state
  }

  // ── Behavior 4: Reveal fade-up (IntersectionObserver) ─────────────────────
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    let staggerIndex = 0;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        // Stagger animation: 80ms between elements in the same batch
        const delay = (staggerIndex % 8) * 80;
        staggerIndex++;
        setTimeout(() => {
          entry.target.classList.add('visible');
        }, delay);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    revealEls.forEach((el) => io.observe(el));
  }

  // ── Active nav link highlight ─────────────────────────────────────────────
  const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
  document.querySelectorAll('.nav-links a').forEach((link) => {
    const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/+$/, '') || '/';
    if (linkPath === currentPath) {
      link.classList.add('active');
    } else {
      link.classList.remove('active');
    }
  });
});
